(function (angular) {
  angular.module('xplenty-designer').factory('DesignerSampleComponent', [
    '$timeout',
    'DesignerComponent',

    function ($timeout, DesignerComponent) {
      function DesignerSampleComponent() {
        DesignerComponent.apply(this);
      }

      DesignerSampleComponent.prototype = new DesignerComponent();

      DesignerSampleComponent.prototype.getData = function () {
        const data = DesignerComponent.prototype.getData.call(this);

        _.extend(data, {
          percentage: angular.isDefined(this.percentage) ? this.percentage : this.defaults.percentage,
        });

        if (data.percentage) data.percentage = Number(data.percentage);

        return data;
      };

      DesignerSampleComponent.prototype.setFormData = function (data) {
        this.setData(data);

        DesignerComponent.prototype.setFormData.call(this, data);
      };

      DesignerSampleComponent.prototype.setData = function (data) {
        this.percentage = data.percentage;

        DesignerComponent.prototype.setData.call(this, data);
      };

      DesignerSampleComponent.prototype.getSchema = function () {
        return DesignerComponent.prototype.getSchema.call(this);
      };

      return DesignerSampleComponent;
    },
  ]);
})(window.angular);
